module.exports = __webpack_public_path__ + "static/media/check.3b90c6bc.svg";